import React from "react";
import { Search } from "lucide-react";

/**
 * SearchBar — unified search input (sharp border + leading icon).
 *
 *  - tone: "light" (default) | "dark" — dark uses zinc-900 background.
 *  - dense: smaller padding
 */
export function SearchBar({
  value,
  onChange,
  placeholder = "Rechercher…",
  tone = "light",
  dense = false,
  className = "",
  testId,
  rightSlot,
}) {
  const wrapBase = "flex items-center gap-2 border border-zinc-900";
  const wrapTone = tone === "dark" ? "bg-zinc-900 text-white" : "bg-white text-zinc-900";
  const pad = dense ? "px-2 py-1.5" : "px-3 py-2";
  const inputBase = "flex-1 outline-none bg-transparent text-sm font-mono";
  const inputTone = tone === "dark" ? "text-white placeholder:text-zinc-500" : "text-zinc-900 placeholder:text-zinc-400";

  return (
    <div className={`${wrapBase} ${wrapTone} ${pad} ${className}`}>
      <Search size={14} className="opacity-70 shrink-0" />
      <input
        data-testid={testId}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`${inputBase} ${inputTone}`}
      />
      {rightSlot}
    </div>
  );
}
